import Footer from 'core/layout/Footer';

/** Kept for existing imports: every public page now gets the full site footer. */
export default Footer;
